import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { getDeviceTypes } from 'store/selectors/DeviceTypes';
import { STATIC_ACCESS_TYPES } from 'utils/constants/access-log';

export function useLogType() {
    const deviceTypes = useSelector(getDeviceTypes);
    const accessMap = useMemo(
        () => ({ ...STATIC_ACCESS_TYPES, ...deviceTypes }),
        [deviceTypes]
    );

    return useCallback(
        log => {
            if (log.lpr_access) return 'LPR';
            if (log.role === 'otc' || log.access_type === 'visitor') return 'Visitor';
            if (log.guard_access) return 'Guard';
            return accessMap[log.access_type] || '';
        },
        [accessMap]
    );
}
